import { page, getById } from '@/api/ship/shipSailingRouteTpl'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(page, getById)
